export default "__VITE_ASSET__Cvg8BIqD__"